import { useHttp } from './http';

const http = useHttp('sensitivity_types');

export default {
  all: () => http.get(null),
};
